import React from "react";
import DisplayMaster from '../DisplayMaster';

export default function Opole() {
  return (
    <>
      <DisplayMaster voivodeship="Opole" />
    </>
  );
}